import { BlobServiceClient, BlockBlobTier } from '@azure/storage-blob';

import { truefileServerApi } from 'api/truefilesServerApi';
import { IFileModel } from 'api/types/trueFileServerTypes';

export async function uploadFile(
  file: File,
  fileType: string,
  applicantId: number,
  applicationId: number,
): Promise<IFileModel> {
  const azureAuthResponse = await truefileServerApi.GET('/api/files/sas/write', {
    params: { query: { fileName: file.name, applicationId, fileType } },
  });

  const blobName = `${azureAuthResponse.data?.storageAccountUrl}${azureAuthResponse.data?.containerName}/${azureAuthResponse.data?.blobName}`;

  const blobServiceClient = new BlobServiceClient(
    `${azureAuthResponse.data!.storageAccountUrl}${azureAuthResponse.data!.sasToken}`,
  );
  const containerClient = blobServiceClient.getContainerClient(azureAuthResponse.data!.containerName);
  const blockBlobClient = containerClient.getBlockBlobClient(azureAuthResponse.data!.blobName);

  await blockBlobClient.uploadData(file, {
    blobHTTPHeaders: { blobContentType: file.type },
    tier: BlockBlobTier.Cold,
  });

  const fileResponse = await truefileServerApi.POST('/api/files', {
    body: {
      fileType,
      blobUrl: blobName,
      fileName: file.name,
      blobname: azureAuthResponse.data!.blobName,
      applicantId,
    },
  });

  return fileResponse.data!;
}
